// extracted by mini-css-extract-plugin
export default {"art":"style_art__s83Gs","artImg":"style_artImg__XUp+w","artPh":"style_artPh__RoeDX"};